/**
 * Global API error handler to prevent unhandled promise rejections
 */
import axios from 'axios';
import i18next from 'i18next';
import { AppConstant } from '../constant/AppConstant';
import { showWarning } from './toastService';

export function setupApiErrorHandler() {
  // Response interceptor to catch all API errors
  axios.interceptors.response.use(
    (response) => {
      // Success - pass through
      return response;
    },
    (error) => {
      // Don't log if this is a cancelled request
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }

      // Handle specific error codes
      const status = error.response?.status;

      if (status === 429) {
        showWarning(i18next.t(AppConstant.TOO_MANY_REQUESTS));
      }

      // Always reject to allow calling code to handle if needed
      // But this prevents unhandled rejection by logging it
      return Promise.reject(error);
    }
  );

  // Also catch any truly unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.isAxiosError) {
      // Prevent the error from being logged as unhandled
      event.preventDefault();
    }
  });
}
